module.exports = __webpack_public_path__ + "img/user-profile.1bdab980.jpg";